export default {
  baseStyle: {
    dialogContainer: {
      p: '10px',
    },
  },
};
